// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"4c79040d","796":"972e9ece"}[chunkId] + ".chunk.js";
};